import { writable, derived } from 'svelte/store';
import type { Models, SkyOS } from '@smartlinkdev/types';
import { browser } from '$app/environment';
import type { MapService } from '$lib/services/map';

export const amenities = writable<Models.Amenity[]>([]);
export const events = writable<Models.Event[]>([]);
export const locations = writable<Models.Location[]>([]);
export const locationCategories = writable<Models.Category[]>([]);
export const floors = writable<Models.Floor[]>([]);
export const roveDefaultFloor = writable<Models.Floor>(undefined);
export const roveActiveFloor = writable<Models.Floor>(undefined)
export const floorTransitions = writable<Models.FloorTransition[]>([]);
export const mapBackgrounds = writable<Models.MapBackground[]>([]);
export const mapTexts = writable<Models.MapText[]>([]);
export const lighting = writable<Models.Lighting[]>([]);
export const mapSuites = writable<Models.MapSuites[]>([]);
export const venue = writable<Models.Venue | undefined>(undefined);
export type MapType = 'mapbox' | 'rove';
export const mapType = derived<Models.Venue, MapType>(
    venue,
    ($venue) => $venue?.settings?.mapType || 'rove',
);

export const activeLocationCategoryId = writable<number | undefined>(undefined);

export const configLoaded = writable(false);

export const currentFloor = writable<SkyOS.Maps.Floor | undefined>(undefined);
export const defaultFloor = writable<SkyOS.Maps.Floor | undefined>(undefined);
export const mapFloors = writable<SkyOS.Maps.Floor[]>([]);
export const mapReady = writable(false);
export const mapInstance = writable<undefined | MapService>(undefined);

export const windowWidth = writable<number>();
export const windowHeight = writable<number>();
if (browser) {
  windowWidth.set(window.innerWidth);
  windowHeight.set(window.innerHeight);
}

export const hideControls = writable<boolean>(false);
export const showDirections = writable<boolean>(false);
export const destinationId = writable<string|undefined>(undefined);
export const leftMenu = writable<boolean>(false);
export const forceRoveMap = writable<boolean>(false);
export const disableInteraction = writable<boolean>(false);
export const enableDirections = writable<boolean>(true);
export const currentLocation = writable<Models.Location|undefined>(undefined);

export const forceHideAmenities = writable<boolean>(false);
export const hideSearch = writable<boolean>(false);
export const emitClicks = writable<boolean>(false);

export const hideAmenities = derived([amenities, forceHideAmenities], ([$amenities, $forceHideAmenities]) => {
  if($forceHideAmenities) return true;
  return $amenities.length === 0;
});

export const expandedLocation = writable<Models.Location|undefined>(undefined);

export const loadingScreenCustomLogoUrl = writable<string>(undefined);

export const drawerOpen = writable<boolean>(false);
export const mobileOpen = writable<boolean>(false);
export const isMobile = writable<boolean>(false);
export const ammenitiesExpanded = writable<boolean>(true);
export const locationsExpanded = writable<boolean>(true);
export const toggleMobile = writable<boolean>(false);
